<template>
  <div v-if="facts.length > 0" class="conversation-facts" dir="rtl">
    <p class="conversation-facts__header">עובדות משיחות בוט 🤖</p>
    <ul class="conversation-facts__list">
      <li v-for="fact in facts" :key="fact.id" class="conversation-facts__item">
        <span class="conversation-facts__note">{{ fact.note }}</span>
        <span class="conversation-facts__date">{{ fact.date }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ConversationFacts',
  props: {
    applicant_id: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      facts: []
    }
  },
  created () {
    this.loadFacts()
  },
  methods: {
    async loadFacts () {
      try {
        const response = await this.$network_utils.getStats({
          designator: 'conversation_fact',
          current_resource_type: 'Applicant',
          current_resource_id: this.applicant_id
        })
        const rows = Array.isArray(response)
          ? response
          : (response && Array.isArray(response.data) ? response.data : [])
        this.facts = this.parseRows(rows)
      } catch (error) {
        this.facts = []
      }
    },
    parseRows (rows) {
      const parsed = []
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i]
        let content
        try {
          content = JSON.parse(row.content)
        } catch (error) {
          continue
        }
        if (!content || !content.note) continue
        parsed.push({
          id: row.id,
          note: content.note,
          date: this.formatDate(content.recorded_at || row.created_at)
        })
      }
      return parsed
    },
    formatDate (value) {
      if (!value) return ''
      const m = this.$moment(value)
      return m.isValid() ? m.format('DD/MM/YY') : ''
    }
  }
}
</script>

<style scoped>
.conversation-facts {
  margin: 12px 0;
  padding: 8px 12px;
  border-right: 3px solid #d0d7de;
  background: #f6f8fa;
  font-size: 12px;
  text-align: right;
}
.conversation-facts__header {
  margin: 0 0 6px;
  color: #6a737d;
  font-weight: bold;
}
.conversation-facts__list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.conversation-facts__item {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 0;
}
.conversation-facts__note {
  color: #24292e;
}
.conversation-facts__date {
  color: #8a929b;
  white-space: nowrap;
}
</style>
